import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowRight, FileText, Printer } from "lucide-react";
import PageShell, { Section } from "@/components/site/PageShell";
import { Note } from "@/components/site/ui";
import Blocks from "@/components/site/Renderer";
import { LEGAL_DOCS, findLegal } from "@/content/legal";

export function LegalIndex() {
  const groups = [...new Set(LEGAL_DOCS.map(d => d.category))];
  return (
    <PageShell eyebrow="Centre juridique" title="Tous nos documents."
      lead="Chaque document indique sa version, sa date d'entrée en vigueur et sa dernière mise à jour.">
      <Section>
        <Note>
          Ces documents sont des trames rédigées à partir du fonctionnement réel du service.
          Ils doivent être relus par un juriste avant toute exploitation commerciale.
        </Note>
      </Section>
      {groups.map(g => (
        <Section key={g} title={g}>
          <div className="card-grid cols-2">
            {LEGAL_DOCS.filter(d => d.category === g).map(d => (
              <div key={d.slug} className="info-card">
                <h3>{d.title}</h3>
                <p>{d.short}</p>
                <small style={{ display: "block", marginTop: 10, fontSize: 11, color: "#97a08f" }}>
                  Version {d.version} · mise à jour le {d.updated}
                </small>
                <Link to={`/legal/${d.slug}`} data-testid={`legal-${d.slug}`}>Lire<ArrowRight size={12} /></Link>
              </div>
            ))}
          </div>
        </Section>
      ))}
    </PageShell>
  );
}

export function LegalDoc() {
  const { slug } = useParams();
  const doc = findLegal(slug);
  if (!doc) return <Navigate to="/legal" replace />;
  return (
    <PageShell eyebrow="Document juridique" title={doc.title} lead={doc.short}
      actions={<>
        <Link to="/legal" className="button button-outline"><FileText size={13} />Tous les documents</Link>
        <button type="button" className="button button-outline" onClick={() => window.print()} data-testid="legal-print"><Printer size={13} />Imprimer</button>
      </>}>
      <Section>
        <div className="legal-meta">
          <div><span>Version</span><strong>{doc.version}</strong></div>
          <div><span>Entrée en vigueur</span><strong>{doc.effective}</strong></div>
          <div><span>Dernière mise à jour</span><strong>{doc.updated}</strong></div>
        </div>
        {doc.draft && (
          <Note>
            <strong>Projet — à faire valider par un juriste.</strong> Ce texte décrit fidèlement le
            fonctionnement du service, mais n'a pas encore été relu par un professionnel du droit.
            Il ne doit pas être opposé à un tiers en l'état.
          </Note>
        )}
      </Section>
      <Section>
        <div className="docs-content" style={{ marginTop: 0 }}>
          {doc.sections.map(s => (
            <section key={s.id} id={s.id}>
              {s.heading && <h2>{s.heading}</h2>}
              <Blocks blocks={s.blocks} />
            </section>
          ))}
        </div>
      </Section>
      <Section title="Questions">
        <p className="section-lead">
          Une question sur ce document ? Écrivez à <a href="mailto:legal@performcustom.com" style={{ color: "var(--green)", textDecoration: "underline" }}>legal@performcustom.com</a>.
        </p>
      </Section>
    </PageShell>
  );
}
